import { render } from "./app-format-number.vue?vue&type=template&id=079e1f6b&ts=true"
import script from "./app-format-number.vue?vue&type=script&lang=ts"
export * from "./app-format-number.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__